import React from 'react';
import {
    Button,
    Modal,
    Alert,
} from 'react-bootstrap';

const MultiDeleteUserModal = (props) =>{
    const {showMultiDelete, currentUser, handleClose, usersSelectedHaveMoreOrgs, handleDeleteMultiple} = props;

    return <Modal show={showMultiDelete} onHide={handleClose}>
          <Modal.Dialog>
            <Modal.Header closeButton>
              <Modal.Title>Delete User</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Your selection includes multiple users. Are you sure you want to delete all selected
                users?
              </p>
              {usersSelectedHaveMoreOrgs() && currentUser.role === 'ORGANIZATION_ADMIN' && (
                <Alert variant="warning">
                  <p>
                    NOTE: Some of the users selected have more organizations assigned, this action
                    will remove them from all.
                  </p>
                </Alert>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="outline-secondary"
                className="btn btn-custom white mr-3"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button variant="outline-danger" onClick={handleDeleteMultiple}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>
}

export default MultiDeleteUserModal;